//import { Toast } from 'vant';
import { Message, MessageBox } from 'element-ui'
import axios from 'axios'
import router from '../router'
import qs from 'qs'
let loginOut = false
axios.defaults.timeout = 60000
axios.defaults.withCredentials = true //意思是携带cookie信息,保持session的一致性
// axios.defaults.baseURL ='https://api.51jincai.com'; //填写域名
// axios.defaults.baseURL ='/apis'; //填写域名
// axios.defaults.baseURL ='http://101.201.79.47:8080'; //填写域名
// axios.defaults.baseURL =''; //填写域名
//console.log(process.env.NODE_ENV)
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/apis' : ''
//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data)
    var user = sessionStorage.getItem('user')
    if (user) {
      user = JSON.parse(user)
    }
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: config.Authorization ? config.Authorization : user ? user.token : ''
    }
    return config
  },
  (error) => {
    return Promise.reject(err)
  }
)
//响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    switch (response.data.code) {
      case -403:
        if (!loginOut) {
          loginOut = true
          MessageBox('登录信息失效,请重新登录！', '温馨提示', {
            confirmButtonText: '取消',
            cancelButtonText: '确定',
            showClose: false,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            localStorage.setItem('cart_list', [])
            router.push('/login')
            loginOut = false
          })
        }

        break
    }
    return response
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          console.log('错误请求')
          break
        case 401:
          console.log('未授权，请重新登录')
          break
        case 403:
          console.log('拒绝访问')
          break
        case 404:
          // console.log('请求错误,未找到该资源')
          Message('请求错误,未找到该资源')
          break
        case 405:
          console.log('请求方法未允许')
          break
        case 408:
          // console.log('请求超时')
          Message('请求超时')
          break
        case 500:
          // console.log('服务器端出错')
          Message({
            message: '服务器出错了，请刷新',
            type: 'warning'
          })
          break
        case 501:
          console.log('网络未实现')
          break
        case 502:
          // location.href = `http://festival.pinuc.com/page/404.html`
          console.log('网络错误')
          break
        case 503:
          console.log('服务不可用')
          break
        case 504:
          console.log('网络超时')
          break
        case 505:
          console.log('http版本不支持该请求')
          break
        default:
          console.log(`连接错误${err.response.msg}`)
      }
    } else {
      console.log('连接到服务器失败')
      console.log(err)
      //       const loading = this.$loading({
      //        lock: true,
      //        text: 'Loading',
      //        spinner: 'el-icon-loading',
      //        background: 'rgba(0, 0, 0, 0.7)'
      //      });
      //       loading.close();
      Message('连接到服务器失败,请刷新')
      //    Toast('连接到服务器失败')
    }
    return Promise.resolve(err.response)
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        url,
        {
          params: params
        },
        headers
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, headers).then(
      (response) => {
        if (response) {
          resolve(response.data)
        }
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * 封装delete方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function DELETE(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios
      .delete(
        url,
        {
          params: params
        },
        headers
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data, headers).then(
      (response) => {
        resolve(response.data)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.put(url, data, headers).then(
      (response) => {
        resolve(response.data)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
/**
 * 下面是获取数据的接口
 */
/**
 * 测试接口
 * 名称：exam
 * 参数：paramObj/null
 * 方式：fetch/post/patch/put
 */
export const server = {
  login: function(data, headers) {
    //登陆
    return post('/entry/loginByFestivalCard', data, headers)
  },
  queryFestivalPackages: function(data, headers) {
    //查询礼包
    return post('/company/queryFestivalPackages', data, headers)
  },
  getFestivalPackage: function(data, headers) {
    //查询礼包
    return post('/company/getFestivalPackage', data, headers)
  },
  queryaddress: function(data, headers) {
    //地址
    data.clientPlatform = 2
    return post('/user/address/query', data, headers)
  },
  querydq: function(data, headers) {
    //地区
    return post('/item/queryRegions', data, headers)
  },
  createaddress: function(data, headers) {
    //新建地址
    data.clientPlatform = 2
    return post('/user/address/create', data, headers)
  },
  updateaddress: function(data, headers) {
    //修改地址
    data.clientPlatform = 2
    return post('/user/address/update', data, headers)
  },
  confirmFestivalPackageOrder: function(data, headers) {
    //兑换礼包
    return post('/itemorder/confirmFestivalPackageOrder', data, headers)
  },
  deleteaddress: function(data, headers) {
    //删除地址
    data.clientPlatform = 2
    return post('/user/address/delete', data, headers)
  },
  queryItemOrders: function(data, headers) {
    //查询订单
    return post('/itemorder/queryItemOrders', data, headers)
  },
  getItemOrder: function(data, headers) {
    //查询订单详情
    return post('/itemorder/getItemOrder', data, headers)
  },
  queryItemOrderExpress: function(data, headers) {
    //查询物流
    return post('/itemorder/queryItemOrderExpress', data, headers)
  },
  getCardUserBalance: function(data, headers) {
    //查询登录用户信息
    return post('/user/getCardUserBalance', data, headers)
  },
  testRefund: function(data, headers) {
    //退款
    return get('/test/testRefund', data, headers)
  },
  previewItemOrder: function(data, headers) {
    //预下单
    return post('/itemorder/previewItemOrder', data, headers)
  },
  verifyItemRegion: function(data, headers) {
    //查询商品是否支持配送
    return post('/item/verifyItemRegion', data, headers)
  },
  getItemDeliveryDesc: function(data, headers) {
    //查询商品是否支持选择配送时间
    return post('/item/getItemDeliveryDesc', data, headers)
  },
  getItemDeliveryTime: function(data, headers) {
    //查询商品是否支持选择配送时间
    return post('/item/getItemDeliveryTime', data, headers)
  },
  createFestivalPackageOrder: function(data, headers) {
    //点数礼包下单
    return post('/itemorder/createFestivalPackageOrder', data, headers)
  },
  queryFestivalCategories: function(data, headers) {
    //查询礼包分类
    return post('/company/queryFestivalCategories', data, headers)
  },
  createpay: function(data, headers) {
    //创建支付
    return post('/pay/create', data, headers)
  },
  verifyTicketCard: function(data, headers) {
    //查询卡
    return post('/pay/verifyTicketCard', data, headers)
  },
  startpay: function(data, headers) {
    //开始支付
    return post('/pay/start', data, headers)
  },
  verifyItemStock: function(data, headers) {
    //查库存
    return post('/item/verifyItemStock', data, headers)
  },
  getSpu: function(data, headers) {
    //
    return post('/item/getSpu', data, headers)
  },
  //校验sku购买限制
  skulimit: function(data, headers) {
    return post('/itemorder/valid-sku-limit', data, headers)
  },
  /**
   * 通过adCode查询所有父级地区
   */
  queryRegionsByAdCode: function(data, headers) {
    return post('/item/queryRegionsByAdCode', data, headers)
  },
  /**
   * 通过商城跳转专区登录
   */
  loginByFestivalCardInMall: function(data, headers) {
    return post('/entry/loginByFestivalCardInMall', data, headers)
  },
  /**
   * 获取公告
   */
  documentlist: function(data, headers) {
    return get('/document/list', data, headers)
  },
  /**
   * 获取公告
   */
  querydoclist: function(data, headers) {
    return get('/doc/list', data, headers)
  },
  /**
   * 把设备添加为信任设备
   */
  addTrustedDevice: function(data, headers) {
    return post('/entry/add-trusted-device', data, headers)
  },
  /**
   * 获取认证信息
   */
  deviceVerifyInfo: function(data, headers) {
    return get('/entry/device-verify-info', data, headers)
  },
  /**
   * 验证用户手机号
   */
  deviceVerifyMobile: function(data, headers) {
    return post('/entry/device-verify-mobile', data, headers)
  },
  /**
   * 用户删除订单
   */
  deleteallorder: function(data, headers) {
    return DELETE('/union-order/hide-order', data, headers)
  },
  /**
   * 查询礼包标签
   */
  queryTags: function(data, headers) {
    return get('/company/queryTags', data, headers)
  },
  /**
   * 查询礼包标签
   */
  queryLocation: function(data, headers) {
    return post('/location/query', data, headers)
  },
  /**
   * 查询礼包标签
   */
  convertMovieLocationToItemRegion: function(data, headers) {
    return post('/location/convertMovieLocationToItemRegion', data, headers)
  },
  /**
   * 查询商品是否支持选择配送时间
   */
  querySkuShippingDate: function(data, headers) {
    return post('/itemorder/query-sku-shipping-date', data, headers)
  }
}
